import { BackgroundData, IBackgroundData } from "./background-data";
import { IMeshData, IVisibility, MeshData, ScrollEffectName } from "./index";
import { IBorderRadiusData } from "./border-data";

export interface IMeshSectionBaseData<TStyle extends ISectionStyle> extends IFavoriteData {
    style?: TStyle | null;
    sectionVisibility?: IVisibility;
    backgroundScrollEffect?: ScrollEffectName;
}

export interface ISectionStyle {
    minHeightInPc: number;
}

export interface IScreenData {
    id?: string;
    background: IBackgroundData;
    content: IMeshedSectionContentData;
}

export interface IMeshedSectionContentData {
    mesh: IMeshData;
    background: IBackgroundData;
    style?: ISectionContentStyle | null;
}

export interface ISectionContentStyle {
    displayShadow?: boolean | null;
    shadowColor?: string;
    borderRadius?: IBorderRadiusData;
    maxWidthInPx?: number | null;
    upperAndBottomMarginsInPc?: number | null;
}

export interface IFavoriteData {
    favorite?: boolean | null;
}

export abstract class MeshedSectionContentData {

    public static get defaultData(): IMeshedSectionContentData {
        return {
            background: BackgroundData.defaultContentData,
            mesh: MeshData.defaultData,
            style: {
                upperAndBottomMarginsInPc: 3,
                borderRadius: {
                    topLeftPx: 0,
                    topRightPx: 0,
                    bottomLeftPx: 0,
                    bottomRightPx: 0
                }
            },
        };
    }

}
